"use client"
import React from 'react'
import dynamic from 'next/dynamic';
import { ContactForm } from '@/components';
const MotionDiv = dynamic(() => import('framer-motion').then(mod => mod.motion.div), { ssr: false });

const contactShow = () => {
  return (
    <MotionDiv
        className="glass-panel relative z-10 max-w-lg px-4 md:max-w-2xl w-full pt-6 text-white rounded-2xl shadow-glow-lg"
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
      >
       <ContactForm/>
      </MotionDiv>
  )
}

export default contactShow